import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import Classes, { NotificationDetail, PositivePayCheckTemplate, User } from "model";


/**
* @class CustomItemTypeCode
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.contactInfo[0];
* const contactInfo = new ContactInfo(record);
* @property {NUMBER} _id - The id of the contact info
*/
export default class CustomItemTypeCode extends BCMSRecord{
    _id
    _template
    _itemTypeMapping
    _itemTypeMappingValue

    constructor (record){     
      super(record) 
    }

  }
  CustomItemTypeCode.define({
    "recordType":"positivePayCustomItemTypeCodes",
    "recordIDProp":"id",
    "className" : "PositivePayCustomItemTypeCodes",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the contact info
       * @property set {NUMBER} - sets the id of the contact info
       * @memberof ContactInfo
       */
      BCMSRecordProperty.mapToString("id","_id"),
      BCMSRecordProperty.mapToClass("template","_template", () => PositivePayCheckTemplate),
      BCMSRecordProperty.mapToString("itemTypeMapping","_itemTypeMapping"),
      BCMSRecordProperty.mapToString("itemTypeMappingValue","_itemTypeMappingValue"),
    ]  
})




